import React, { useState } from 'react';
import { useLang } from '../context/LanguageContext';
import { PRODUCT } from '../data/products';

export default function Ingredients() {
  const { t } = useLang();
  const ing = t.ingredients;
  const [expanded, setExpanded] = useState(false);

  return (
    <section id="ingredients" className="py-24 bg-misky-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-misky-mid text-xs uppercase mb-3">{ing.sectionLabel}</p>
          <h2 className="text-4xl sm:text-5xl font-bold text-misky-black">{ing.title}</h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {ing.items.map((item, i) => (
            <div key={i} className="lift group p-6 rounded-3xl border border-misky-silver bg-white text-center shadow-sm">
              <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-misky-black flex items-center justify-center text-2xl group-hover:scale-110 transition-transform">
                {item.icon}
              </div>
              <h3 className="font-semibold text-misky-black mb-2 text-sm leading-tight">{item.name}</h3>
              <p className="text-xs text-misky-mid leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="bg-misky-black rounded-3xl p-8 md:p-10">
          <h3 className="text-xl font-bold text-white mb-4">{ing.fullListLabel}</h3>
          <p className={`text-misky-light text-sm leading-relaxed ${!expanded ? 'line-clamp-3' : ''}`}>
            {PRODUCT.ingredients}
          </p>
          <button
            onClick={() => setExpanded(!expanded)}
            className="mt-4 text-xs text-white/60 hover:text-white underline underline-offset-4 transition-colors"
          >
            {expanded ? ing.showLess : ing.showFull}
          </button>
        </div>
      </div>
    </section>
  );
}
